const Style = {

  loading: 'relative py-8',
  row: 'mb-4',
  title: 'font-semibold text-lg',

}

export default Style;